import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import OperateLogModuleTypes from '@/store/modules/middleGround/member/operateLog/interface';

const subCompanyListModule: Module<OperateLogModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageOperateLogList(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/pageOperateLogList", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
    },
};

export default subCompanyListModule;